import React, { useState, useEffect, useContext } from "react";
import Background from "../../img/Phone-Collections.png";
import LoadingImage from "../../img/FengLoaderWhitePNG.png";
import RadioButtonIcon from "../../common/RadioButtonIcon";
import BoxText from "../../common/BoxText";
import CheckoutBottom from "./Bottom";
import RadioButtonSlide from "../../common/radioButtonSlide";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  fetchCurrentConfigTheme,
  fetchCheckoutBottomData,
  updateCheckoutBottomData,
} from "../../../api";

function CartCheckoutBottom({ storeKey }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [isSaving, setIsSaving] = useState(false); // Saving state
  const [isSelected, setIsSelected] = useState();
  const [block, setBlock] = useState("roundedArc");
  const [isColor, setIsColor] = useState("#CCCCCC");
  const [isActive, setActive] = useState(true);
  const [color1, setColor1] = useState();
  const [templateID, setTemplateID] = useState();

  useEffect(() => {
    const storedTemplateID = localStorage.getItem("rootTemplateID");
    if (storedTemplateID) {
      setTemplateID(storedTemplateID);
    } else {
      getCurrentConfigTheme();
    }
  }, []);

  useEffect(() => {
    if (templateID) {
      fetchData();
    }
  }, [templateID]);

  useEffect(() => {
    // This function is run whenever `isActive` changes
    updateColorComponent();
  }, [isActive]); // Dependency array. Only re-run the effect if `isActive` changes.

  const getCurrentConfigTheme = () => {
    setIsLoading(true);
    // API
    fetchCurrentConfigTheme(storeKey)
      .then((response) => {
        const templateID = response.data;
        if (templateID) {
          setTemplateID(templateID);
        } else {
          console.error("Error fetching: No template ID in the response");
        }
      })
      .catch((error) => {
        console.error("Error fetching current Theme:", error);
      });
  };

  const fetchData = () => {
    // API
    fetchCheckoutBottomData(storeKey, templateID)
      .then((response) => {
        // Here's the change
        const data = response.data;
        const colorData = data.color;
        const cartData = data.checkout;

        if (colorData) {
          setColor1(colorData.mainColor);
        }
        if (cartData) {
          if (cartData.buttonIsRounded && cartData.curvedPath) {
            setIsSelected(1);
            setBlock("roundedArc");
          }
          if (cartData.buttonIsRounded && !cartData.curvedPath) {
            setIsSelected(2);
            setBlock("roundedSimple");
          }
          if (!cartData.buttonIsRounded && cartData.curvedPath) {
            setIsSelected(3);
            setBlock("squareArc");
          }
          if (!cartData.buttonIsRounded && !cartData.curvedPath) {
            setIsSelected(4);
            setBlock("squareSimple");
          }
          setActive(cartData.color ? true : false);
          setIsColor(cartData.color || "#CCCCCC");
        } else {
          setIsColor("#CCCCCC");
          setIsSelected(1);
        }

        setIsLoading(false); // Set loading state to false after data is loaded
      })
      .catch((error) => {
        console.error("Error fetching cart checkout data:", error);
        setIsLoading(false); // Set loading state to false after data is loaded
      });
  };

  const updateConfig = async () => {
    setIsSaving(true);

    // API
    updateCheckoutBottomData(
      storeKey,
      templateID,
      isSelected == 1 || isSelected == 2,
      isSelected == 1 || isSelected == 3,
      isActive ? isColor : null
    )
      .then((response) => {
        updateColorComponent();
        setIsSaving(false);
      })
      .catch((error) => {
        console.error("Error updateCheckoutBottomData:", error);
      });
  };

  const updateColorComponent = () => {
    if (isActive == false) {
      setIsColor(color1);
    }
  };

  const checkedChange = (e) => {
    setBlock(e.target.name);
    setIsSelected(Number(e.target.value));
  };

  const colorChange = (e) => {
    setIsColor(e.target.value);
    setActive(true);
  };

  const handleToggle = () => {
    setActive(!isActive);
  };

  return (
    <section className="--checkoutBottom productList row">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <img src={LoadingImage} alt="Loading" />
          </div>
          <div className="loading-text">{t("common.loading")}</div>
        </div>
      )}
      {isSaving && (
        <div className="loading-overlay">
          <div className="loading-content">
            <img src={LoadingImage} alt="Loading" />
          </div>
          <div className="loading-text">{t("common.saving")}</div>
        </div>
      )}
      <div className="info__edit col">
        <div className="titles__page">
          <h2 className="title primary">{t("checkout.title")}:</h2>
          <nav
            className="componentNav"
            style={{  marginTop: "10px" }}
          >
            <ul className="componentList">
              <li className="itemList">
                <Link to="/cart" style={{ color: "#6D7A8B" }}>
                  LIST STYLE
                </Link>
              </li>
              <li className="itemList">
                <Link to="/qty-stepper" style={{ color: "#6D7A8B" }}>
                  QUANTITY STEPPER
                </Link>
              </li>
              <li className="itemList active">
                BOTTOM
                <BoxText handleSaveButton={updateConfig}>
                {t("checkout.descriptionBottom")}
                </BoxText>
              </li>
            </ul>
          </nav>
        </div>

        <div className="settingsGroup row">
          <h2 className="title">Themes:</h2>
          <div className="col settings radios">
            <RadioButtonIcon
              label="ROUNDED ARC"
              id="roundedArc"
              value={1}
              onChange={checkedChange}
              check={isSelected}
              title="Rounded Arc"
              description=""
              video="./sidevideos/checkoutBottom1.mp4"
            />
            <RadioButtonIcon
              label="ROUNDED SIMPLE"
              id="roundedSimple"
              value={2}
              onChange={checkedChange}
              check={isSelected}
              title="Rounded Simple"
              description=""
              video="./sidevideos/checkoutBottom2.mp4"
            />
            <RadioButtonIcon
              label="SQUARE ARC"
              id="squareArc"
              value={3}
              onChange={checkedChange}
              check={isSelected}
              title="Square Arc"
              description=""
              video="./sidevideos/checkoutBottom3.mp4"
            />
            <RadioButtonIcon
              label="SQUARE SIMPLE"
              id="squareSimple"
              value={4}
              onChange={checkedChange}
              check={isSelected}
              title="Square Simple"
              description=""
              video="./sidevideos/checkoutBottom4.mp4"
            />
          </div>
        </div>

        <div className="settingsGroup row">
          <h2 className="title">Colors:</h2>
          <div className="row radioCustom --colors">
            <RadioButtonSlide
              label="CUSTOM COLORS"
              isActive={isActive}
              onClick={handleToggle}
            />
            <div className="contentColors">
              <input
                type="text"
                name="textColors"
                className="textColor"
                value={isColor}
                onChange={colorChange}
              />
              <input
                type="color"
                name="colors"
                className="pickColor"
                value={isColor}
                onChange={colorChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="img__edit col-md2"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <CheckoutBottom theme={block} color={isColor} />
      </div>
    </section>
  );
}

export default CartCheckoutBottom;
